import React, {Component} from "react";
import {connect} from "react-redux";
import {AutoComplete, BackTop, Button, Col, Empty, Form, Row, Select, Skeleton, Table, Typography,} from "antd";
import {CSVLink} from "react-csv";
import {fetchLeasableAssetData, getLeasablesCostings} from "../../appRedux/actions";

const {Text} = Typography;

const PAGE_SIZE = 10;

class LeasingCalculation extends Component {
  state = {
    currentPage: 1,
    costData: [],
    inputAsset: '',
    reportType: 'm'
  };
  componentDidMount = () => {
    this.props.setPageTitle('Leasing Calculation')
  }
  componentWillUnmount = () => {
    this.props.setPageTitle('');
  }

  fetchData = (asset, type) => {
    this.props.getLeasablesCostings({asset, type, pageSize: PAGE_SIZE});
    // this.props.getLeasingCostCalculation({asset: '61efd5f56e3a1b7ebd200442'});
  };

  onClickSearch = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if(!err) {
        const {inputAsset, reportType} = this.state;
        this.fetchData(inputAsset, reportType);
      }
    });
  };

  onSelectReportType = (val) => {
    this.setState({
      reportType: val
    })
  };

  onSelect = (val) => {
    this.setState({
      inputAsset: val
    })
  };

  onChangeAsset = (val) => {
    if(!val) {
      this.setState({
        inputAsset: ''
      })
    }
  };

  assetSearch = (value, model = 'Asset', field = 'assetCode') => {
    if(value && value.length >= 2)
      this.props.fetchLeasableAssetData(value, model, field);
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const assetInput = (
      <div>
        <Form onSubmit={this.onClickSearch} className="report-form">
          <Row>
            <Col span={6}>
              <Form.Item>
                {getFieldDecorator('asset', {
                  rules: [{required: true, message: 'Please select asset!'}],
                })(
                  <AutoComplete re allowClear onChange={this.onChangeAsset} onSelect={this.onSelect}
                                onSearch={this.assetSearch}
                                style={{width: '100%'}}
                                placeholder={'Asset Code'}>
                    {
                      (this.props.assetData || []).map(item => (
                        <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>))
                    }
                  </AutoComplete>
                )}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item>
                {getFieldDecorator('reportType', {
                  rules: [{required: true, message: 'Please select report type!'}],
                  initialValue: "m"
                })(
                  <Select style={{width: '100%'}} onChange={this.onSelectReportType}>
                    <Select.Option value="a">Annually</Select.Option>
                    <Select.Option value="h">Bi-Annually</Select.Option>
                    <Select.Option value="q">Quarterly</Select.Option>
                    <Select.Option value="m">Monthly</Select.Option>
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={3}><Button htmlType="submit" disabled={this.state.disableSearch} type="primary"
                                  icon="search">Search</Button></Col>

            <Col span={3}>
              <CSVLink
                data={this.props.datas}
                asyncOnClick={true}
                filename={"leasing-calculation-report-" + Date.now() + ".csv"}
                target="_blank">
                <Button disabled={(!(this.props.datas && this.props.datas.length > 0))} icon="download">CSV</Button>
              </CSVLink></Col>
          </Row></Form></div>);

    let assets = <Skeleton active/>;

    if(this.props.loading === false) {
      // console.log(this.props.costData);
      if(!this.props.datas || this.props.datas.length > 0) {
        const cols = [
          {
            title: "Asset Code",
            dataIndex: "assetCode",
            key: "assetCode",
            // ...this.getColumnSearchProps('assetCode'),
            width: 120,
            fixed: 'left',
            sorter: (a, b) => (a.assetCode > b.assetCode) ? -1 : (a.assetCode < b.assetCode) ? 1 : 0,
          },
          {
            title: "Asset Type",
            dataIndex: "assetType",
            key: "assetType",
            width: 150,
            ellipsis: true,
            sorter: (a, b) => (a.assetType > b.assetType) ? -1 : (a.assetType < b.assetType) ? 1 : 0,
            // ...this.getColumnSearchProps('assetType'),
          },
          {
            title: "Asset Sub Type",
            dataIndex: "assetSubType",
            key: "assetSubType",
            width: 150,
            ellipsis: true,
            sorter: (a, b) => (a.assetSubType > b.assetSubType) ? -1 : (a.assetSubType < b.assetSubType) ? 1 : 0,
            // ...this.getColumnSearchProps('assetSubType'),
          },
          {
            title: "Asset Model",
            dataIndex: "assetModel",
            key: "assetModel",
            width: 150,
            ellipsis: true,
            sorter: (a, b) => (a.assetModel > b.assetModel) ? -1 : (a.assetModel < b.assetModel) ? 1 : 0,
            // ...this.getColumnSearchProps('assetModel'),
          },
          {
            title: "Current Status",
            dataIndex: "status",
            key: "status",
            // ...this.getColumnSearchProps('status'),
            // filters: [{text: 'Available', value: 'Available'}, {text: 'Under Lease', value: 'Under Lease'}],
            // render: (_, record) => this.getStatus(record.id),
            width: 100,
            // sorter: (a, b) => (a.text > b.text) ? -1 : (a.text < b.text) ? 1 : 0,
          },
          {
            title: "Lease From",
            dataIndex: "leasingDate",
            key: "leasingDate",
            // ...this.getColumnSearchProps('status'),
            // filters: [{text: 'Available', value: 'Available'}, {text: 'Under Lease', value: 'Under Lease'}],
            // render: (_, record) => this.fetchAssociateData(record.id, 'leasingDate'),
            width: 100,
            // sorter: (a, b) => (a.text > b.text) ? -1 : (a.text < b.text) ? 1 : 0,
          },
          {
            title: "Adjusted Market Value",
            dataIndex: "marketValue",
            key: "marketValue",
            render: (_, record) => Number(record.marketValue).toFixed(2),
            width: 150,
          },
          {
            title: "BreakUp",
            dataIndex: "breakupFieldName",
            key: "breakupFieldName",
            // render: (_, record) => this.getIdealDays(record.id),
            width: 100,
            sorter: (a, b) => a.breakupFieldName.length - b.breakupFieldName.length,
          },
          {
            title: "Maintenance Cost",
            dataIndex: "maintenanceCost",
            key: "maintenanceCost",
            render: (_, record) => Number(record.maintenanceCost).toFixed(2),
            width: 150,
          },
          {
            title: "Revenue Till Date",
            dataIndex: "revenue",
            key: "revenue",
            render: (_, record) => Number(record.revenue).toFixed(2),
            width: 150,
          },
          {
            title: "Ideal Days",
            dataIndex: "idealDays",
            key: "idealDays",
            // render: (_, record) => this.getIdealDays(record.id),
            width: 100,
            // fixed: 'right',
          },
          {
            title: "Date since in OPS",
            dataIndex: "opsDay",
            key: "opsDay",
            // render: (_, record) => this.getIdealDays(record.id),
            width: 100,
            // fixed: 'right',
          },
          {
            title: "EBIT",
            dataIndex: "ebit",
            key: "ebit",
            render: (_, record) => Number(record.ebit).toFixed(2),
            width: 100,
          },
          {
            title: "ROI",
            dataIndex: "roi",
            key: "roi",
            render: (_, record) => Number(record.roi).toFixed(2) + '%',
            width: 100,
          },
          {
            title: "Ann ROI",
            dataIndex: "annRoi",
            key: "annRoi",
            render: (_, record) => Number(record.annRoi).toFixed(2) + '%',
            width: 100,
          },
          {
            title: "Unrecovered",
            dataIndex: "unRecovered",
            key: "unRecovered",
            render: (_, record) => Number(record.unRecovered).toFixed(2),
            width: 100,
          },
        ];
        // console.log(this.state.assetData);
        const assetDatas = (this.props.datas || []);

        assets = (
          <>
            <Table
              onChange={this.handleTableChange}
              dataSource={assetDatas}
              // pagination={false}
              pagination={{pageSize: PAGE_SIZE}}
              columns={cols}
              loading={this.props.loading}
              scroll={{x: true}}
              // scroll={{ y: 250 }}
              // rowKey={(record) =>
              //   record.type +
              //   record.location._id +
              //   (record.client && record.client._id)
              // }
            />

          </>
        );
      } else assets = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE}/>;
    }


    return (
      <div>
        <BackTop/>
        {assetInput}
        {assets}
      </div>
    );
  }
}

const mapStateToProps = ({auth, commonData, leasing}) => {
  return {
    authUser: auth.authUser,
    loading: commonData.loading,
    // costData: leasing.costCalculationData,
    assetData: commonData.relationshipSearch,
    datas: leasing.calculationData,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    // getLeasingCostCalculation,
    getLeasablesCostings,
    fetchLeasableAssetData
  };
}

const reportCalculationForm = Form.create({name: 'reportCalculationForm'})(LeasingCalculation);
export default connect(mapStateToProps, mapDispatchToProps())(reportCalculationForm);
